export const HOUR_MS = 60 * 60 * 1000;

export const MIN_WIDTH_RECEIVED = 278;
export const MIN_WIDTH_TIMER = 284;
export const MIN_WIDTH_LONG_TIMER = 305;
